import React from "react";
import useTheme from "./hooks/useTheme";
import "./ThemeSelector.css";
import modeImg from "../components/assets/mode-icon.svg";

export default function ThemeSelector() {
  const themeColor = ["#58249c", "#249c6b", "#b70233"];
  const { changeColor,changeMode,mode } = useTheme();
  const toggleMode = () =>{
    changeMode(mode==='dark'?'white':'dark')
  }
  return (
    <div className="theme-selector">
      <div className="mode-toggle">
        <img
          src={modeImg}
          onClick={toggleMode}
          alt='B/W toggler'
          style={{ filter: mode === "dark" ? "invert(100%)" : "invert(20%)" }}
        />
      </div>
      <div className="theme-buttons">
        {themeColor.map((color) => (
          <div
            key={color}
            onClick={() => changeColor(color)}
            style={{ background: color }}
          />
        ))}
      </div>
    </div>
  );
}
